import React from 'react';
import { Button, Content, ContentVariants } from '@patternfly/react-core';
import ErrorIcon from '@patternfly/react-icons/dist/esm/icons/error-circle-o-icon';
import { LocaleContext } from '../context/LocaleContext';
const FeedbackError = ({ onCloseModal }) => {
    const intl = React.useContext(LocaleContext);
    return (React.createElement("div", { className: "chr-c-feedback-success-content" },
        React.createElement(ErrorIcon, { color: "var(--pf-global--danger-color--100)", className: "pf-u-mx-auto" }),
        React.createElement(React.Fragment, null,
            React.createElement(Content, { component: ContentVariants.h1 }, intl.somethingWentWrong),
            React.createElement(Content, null,
                intl.problemProcessingRequest,
                ' ',
                React.createElement("a", { target: "_blank", href: "https://access.redhat.com/support", rel: "noreferrer" }, intl.getSupport))),
        React.createElement(Button, { variant: "primary", onClick: onCloseModal }, intl.close)));
};
export default FeedbackError;
